import { useScrollDeepLinkedEventIntoView } from '@frontend/calendar-grid';
import { useCalendarDeepLinkParams } from './use-calendar-deep-link-params';

export const useDeepLinkedEvent = ({
  selectedEventIds,
  eventCardRef,
}: {
  selectedEventIds: (string | undefined)[] | undefined;
  eventCardRef?: React.RefObject<HTMLElement | null>;
}) => {
  const { isDeepLinkedEvent } = useCalendarDeepLinkParams(selectedEventIds);

  // Auto-scroll the deep linked card into view on initial load
  useScrollDeepLinkedEventIntoView({
    isDeepLinkedEvent,
    elementRef: eventCardRef ?? { current: null },
  });

  return { isDeepLinkedEvent, eventCardRef };
};
